import Phaser from 'phaser';

import { AvailableFontSizes, TextService } from '../../services/text-service';
import { ResizeMetrics } from '../../model/resize-metrics';
import { Subscription } from 'rxjs';
// import { UxMetrics } from '../../model/ux-metrics';
import { TwentyOneMainScene } from '../../scenes/twentyone-main-scene';
import { ScoreLabelViewModel } from './score-label-view-model';
import { UxMetrics } from '../../model/ux-metrics';
// import { DebugContainerVisual } from '../debug/debug-container-visual';

export class ScoreLabelView extends Phaser.GameObjects.Container {
  private currentResizeMetrics?: ResizeMetrics;
  private subscriptionGroup: Subscription;

  private label: Phaser.GameObjects.Text;
  private activeTween?: Phaser.Tweens.Tween; // Store active tween

  constructor(
    scene: TwentyOneMainScene,
    x: number,
    y: number,
    private viewModel: ScoreLabelViewModel,
  ) {
    super(scene, x, y);

    // new DebugContainerVisual(scene, this);

    this.subscriptionGroup = new Subscription();

    const fontStyle = TextService.fontStyleBold(
      AvailableFontSizes.XLarge,
      this.viewModel.labelColor,
      this.viewModel.defaultFontFamily,
    );

    this.label = this.scene.add.text(0, 0, '', fontStyle).setOrigin(0.5, 0.5);
    this.add(this.label);

    this.setName(ScoreLabelView.name);
    scene.add.existing(this);

    this.subscriptionGroup.add(
      this.viewModel.currentScore$.subscribe((payload) => {
        if (payload.value !== this.label.text) {
          if (payload.instant) {
            this.label.text = payload.value;
            this.refreshLayout();
          } else {
            this.animateLabel(payload.value);
          }
        }
      }),
    );
  }

  override destroy(fromScene?: boolean | undefined): void {
    this.subscriptionGroup.unsubscribe();

    super.destroy(fromScene);
  }

  public onResize(resizeMetrics: ResizeMetrics) {
    this.currentResizeMetrics = resizeMetrics;
    this.refreshLayout();
  }

  private animateLabel(value: string): void {
    // Stop any existing tween
    if (this.activeTween && this.activeTween.isPlaying()) {
      this.activeTween.stop();
      this.label.setAlpha(1); // ensure it's visible
      this.refreshLayout();
    }

    // Start fade-out → set text → fade-in
    this.activeTween = this.scene.tweens.add({
      targets: this.label,
      alpha: 0,
      duration: UxMetrics.ScoreFadeDuration,
      ease: Phaser.Math.Easing.Sine.InOut,
      onComplete: () => {
        this.label.text = value;
        this.refreshLayout();

        this.activeTween = this.scene.tweens.add({
          targets: this.label,
          alpha: 1,
          duration: UxMetrics.ScoreFadeDuration,
          ease: Phaser.Math.Easing.Sine.InOut,
          onComplete: () => {
            this.activeTween = undefined;
          },
        });
      },
    });
  }

  private refreshLayout(): void {
    if (!this.currentResizeMetrics) {
      return;
    }
    const layoutConfig = this.currentResizeMetrics.layoutConfig;
    const scalingMetrics = this.currentResizeMetrics.scalingMetrics;

    this.label.setFontSize(this.currentResizeMetrics.fontMetrics.XLarge);

    const padding = layoutConfig.paddingSm * scalingMetrics.scaleFactor;
    this.setSize(this.label.width + padding * 2, this.label.height + padding);
  }
}
